/**
 * See All Button DOM Component
 *
 * Renders the "See All" button shown by the Sold listing (NHS20-8826) once there are more than
 * 10 sold homes. Its click isn't wired here — plugins/listView.plugin.js catches it via event
 * delegation on the panel (matching on data-sold-see-all-button), the same way it already
 * catches clicks on content rendered deeper in the tree — so this component only owns the
 * button's markup and show/hide, not its behavior.
 *
 * @module nativeInteractiveSiteMap/components/seeAllButton.dom
 */

import fastdom from 'fastdom';

export default function createSeeAllButton() {
  const buttonElement = document.createElement('button');
  buttonElement.type = 'button';
  buttonElement.className = 'nhs-c-native-interactive-site-map__see-all-button';
  buttonElement.textContent = 'See all';
  buttonElement.setAttribute('data-sold-see-all-button', '');
  buttonElement.setAttribute('data-qa', 'native_ism_sold_see_all_button');

  return {
    getElement() {
      return buttonElement;
    },
    show() {
      fastdom.mutate(() => {
        buttonElement.hidden = false;
      });
    },
    hide() {
      fastdom.mutate(() => {
        buttonElement.hidden = true;
      });
    },
    remove() {
      fastdom.mutate(() => {
        buttonElement.remove();
      });
    },
  };
}
